import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const CompanySnapshot = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="company-snapshot"
      className="bg-white border-b border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-8">
            {t.snapshot.title}
          </p>
          <div className="flex flex-wrap gap-3">
            {t.snapshot.items.map((it, i) => (
              <span
                key={i}
                data-testid={`snapshot-item-${i}`}
                className="inline-flex items-center gap-2.5 border border-stone-300 px-4 py-2.5 text-xs md:text-sm font-medium tracking-wide text-[#1A1C19]"
              >
                <span className="h-1.5 w-1.5 bg-[#B5A68B]" />
                {it}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
